import { DOCUMENT } from "@angular/common";
import { Component, HostListener, Inject, OnDestroy, OnInit } from "@angular/core";
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationError,
  RouteConfigLoadStart,
  Router
} from '@angular/router';
import { Subscription} from 'rxjs';

import { AuthenticationService } from '@core/services/authentication.service';
import { PropertiesService } from '@core/services/properties.service';
import { UserService } from '@core/services/user.service';
import { CustomEventService } from '@shared/services/custom-event.service';

import ActionTypesEnum from '@shared/enums/action-constant.enum';

import VERSION from '@env/version';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AdminService } from "@shared/services/admin.service";
import { MenuTypeEnum } from "@shared/enums/sign-up-type.enum";
import { VersionService } from "@shared/services/version.service";

@UntilDestroy()
@Component({
  selector: 'layout-default',
  templateUrl: './default.component.html'
})
export class LayoutDefaultComponent implements OnInit, OnDestroy {

  isFetching = false;
  isCollapsed = false;
  triggerTemplate = null;
  activeUser: ActiveUser.ActiveUserModel;
  kioskMode = false;
  version: string;

  customEventSubscription: Subscription;

  licenseKeyConfig: any;
  currentDate: Date = new Date;
  date1: Date;
  licenceType: any;
  sidebarInfo :any;
  HamburgerMenu = MenuTypeEnum.HAMBURGER;
  CollapseMenu = MenuTypeEnum.COLLAPSE;
  menuStyleLoading: boolean;
  menuStyle: any;
  showAbleMenus: any;
  feVersion: Version.VersionModel;
  beVersion: Partial<Version.VersionModel>

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private route: ActivatedRoute,
    private customEventService: CustomEventService,
    public propertiesService: PropertiesService,
    private router: Router,
    private _message: NzMessageService,
    public userService: UserService,
    public authenticationService: AuthenticationService,
    private adminService: AdminService,
    private versionService: VersionService
  ) {
    router.events.pipe(untilDestroyed(this)).subscribe(evt => {
      if (!this.isFetching && evt instanceof RouteConfigLoadStart) {
        this.isFetching = true;
      }
      if (evt instanceof NavigationError) {
        this.isFetching = false;
        _message.error(`Unable to load ${evt.url} routing`, {
          nzDuration: 1000 * 3
        });

        console.log('evt.error', evt.error);

        return;
      }
      if (!(evt instanceof NavigationEnd)) {
        return;
      }

      setTimeout((): void => {
        this.isFetching = false;
      }, 200);

      this.version = VERSION.version;
    });

    this.activeUser = this.userService.activeUser;
  }

  ngOnInit(): void {
    this.customEventService.eventAnnounced$.pipe(
      untilDestroyed(this)
    ).subscribe(({ action, data }) => {
      if (action === ActionTypesEnum.CHANGE_MENU_STYLE) {
        this.menuStyleLoading = true;
        this.sidebarInfo = data;
        if(this.sidebarInfo.parameterValue === 'HAMBURGER') {
          this.menuStyle = this.HamburgerMenu;
        }
        else if(this.sidebarInfo.parameterValue === 'COLLAPSE'){
          this.menuStyle = this.CollapseMenu;
        }
      }
      this.menuStyleLoading = false;

    });
    this.userService.getSidebarInfo(this.activeUser.id, 'MENU_TYPE').pipe()
      .subscribe( response => {
        this.sidebarInfo = response;
        this.showAbleMenus = response.showAbleMenus;
        this.menuStyleLoading = true;

        if(this.sidebarInfo.parameterValue === 'HAMBURGER') {
          this.menuStyle = this.HamburgerMenu;
        }
        else if(this.sidebarInfo.parameterValue === 'COLLAPSE'){
          this.menuStyle = this.CollapseMenu;
        }
        this.menuStyleLoading = false;
      }, error => {
        console.log('error while updating user password', error);
      });
    this.adminService.getLicenseKey()
      .pipe(untilDestroyed(this))
      .subscribe(response => {
        this.licenseKeyConfig = response?.expireDate;
        this.licenceType = response?.licenceType;
        this.date1 = new Date(this.licenseKeyConfig);
        this.isDateEqual();
        this.almostEqual();
      }, error => {
        console.log('error while fetching license key', error);
      });

    this.customEventSubscription = this.customEventService.eventAnnounced$
      .pipe(untilDestroyed(this)).subscribe(
      ({ action, data }) => {
        if (action === ActionTypesEnum.LOG_OUT) {
          this.authenticationService.logOut();
        }

        if (action === ActionTypesEnum.CHANGE_COLLAPSE) {
          this.isCollapsed = data ? data : !this.isCollapsed;
        }

        if (action === ActionTypesEnum.TOGGLE_KIOSK_MODE) {
          this.kioskMode = !this.kioskMode;
        }

        if (action === ActionTypesEnum.UPDATE_AVATAR) {
          this.userService.getAuthenticatedUser()
            .subscribe(_ => {
              this.activeUser = this.userService.activeUser;
            }, error => {
              console.log('error while fetching user data', error);
            });
        }

        if (action === ActionTypesEnum.TUTORIAL_MODE) {
          this.userService.tutorialMode(this.activeUser.id, data)
            .subscribe(_ => {
                window.location.reload();
            }, error => {
              console.log('error while fetching user data', error);
            });
        }
      });

    this.feVersion = this.propertiesService.VERSION;

    this.versionService.get().pipe(untilDestroyed(this)).subscribe((response: Version.BEVersionModel) => {
      const version = response.version.split("-")[0];

      this.beVersion = {
        version
      };
    }, error => {
      console.log('error while fetching version info', error);
    });
  }

  @HostListener('document:keydown.escape', ['$event'])
  keyEvent() {
    if (this.kioskMode) {
      this.customEventService.announceEvent(ActionTypesEnum.TOGGLE_KIOSK_MODE);
    }
  }

  showVersion(){
    this.router.navigate(['/version']);
  }

  isDateEqual() {
    if (this.date1 <= this.currentDate) {
      return true;
    }
    return false;
  }

  almostEqual() {
    const lastTime = new Date(this.date1).getTime() - this.currentDate.getTime();
   const getLastTime =  Math.ceil(lastTime / (1000 * 3600 * 24));

    if (this.date1 > this.currentDate && getLastTime <= 10) {
      return true;
    }
    return false;
  }
  ngOnDestroy(): void {
    this.customEventSubscription.unsubscribe();
  }
}
